import React from "react";
import MapTo from "@utils/mapto";

const PageNavigation = (props) => {

    const { previousCta, nextCta, previousLabel, nextLabel } = props.content;

    return (
        <div className="page-navigation text-center py-[80px] px-[35px] pb-[180px] flex flex-col justify-between max-w-default mx-auto lg:flex-row lg:justify-center">
            <div className="flex flex-1 flex-col items-center w-1/2 pt-0 pb-[80px] lg:pb-0 md:px-[40px] border-b-[2px] border-[#6494A1] lg:border-b-0 lg:pr-[140px] lg:border-r-[2px] lg:border-[#6494A1] lg:pt-[20px]">
                {previousLabel && <div className="text-p lg:text-h4 font-bold text-light_green mb-[32px]">{previousLabel}</div>}
                {previousCta && <MapTo key={previousCta.id} {...previousCta} />}
            </div>
            <div className="flex flex-1 flex-col items-center w-1/2 pt-[80px] pb-0 lg:pb-[20px] md:px-[40px] lg:pl-[140px] lg:pt-[20px] justify-center">
                {nextLabel && <div className=" text-p font-bold lg:text-h4 text-light_green mb-[32px]">{nextLabel}</div>}
                {nextCta && <MapTo key={nextCta.id} {...nextCta} />}
            </div>
        </div>
    )
};

export default PageNavigation; 